module.exports = __webpack_public_path__ + "media/icons/wind-3a7fbd30deb09a52d946353abab5f16d.svg";